(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-card-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kinsora-card-gallery')) {
    customElements.define('kinsora-card-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const track = this.querySelector('.kc-gallery__track');
        const controls = this.querySelector('.kc-gallery__controls');
        if (!track || !controls) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const slides = [...track.children];
        const dots = [...this.querySelectorAll('.kc-gallery__dots span')];
        const positions = [...this.querySelectorAll('[data-position]')];
        const previous = this.querySelector('[data-step="-1"]');
        const next = this.querySelector('[data-step="1"]');
        const rtl = getComputedStyle(track).direction === 'rtl';
        let current = 0;
        let target = 0;
        let gesture = null;
        let suppressUntil = 0;
        let frame = 0;
        let settleTimer = 0;
        const hydrate = i => {
          const placeholder = slides[i]?.querySelector('template[data-gallery-image]');
          if (placeholder) placeholder.replaceWith(placeholder.content.cloneNode(true));
        };
        const hydrateNeighbors = i => {
          hydrate(i);
          hydrate(i + 1);
          hydrate(i - 1);
        };
        const index = () => Math.max(0, Math.min(slides.length - 1, Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1))));
        const sync = () => {
          current = index();
          hydrate(current);
          slides.forEach((slide, i) => { slide.tabIndex = i === current ? 0 : -1; });
          dots.forEach((dot, i) => dot.classList.toggle('is-current', i === current));
          positions.forEach((position, i) => { position.hidden = i !== current; });
          previous.disabled = current === 0;
          next.disabled = current === slides.length - 1;
        };
        const go = (value, instant = false) => {
          target = Math.max(0, Math.min(slides.length - 1, value));
          hydrate(target);
          track.scrollTo({ left: target * track.clientWidth * (rtl ? -1 : 1), behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        controls.hidden = false;
        controls.addEventListener('click', event => {
          const button = event.target.closest('[data-step]');
          if (button) go(target + Number(button.dataset.step));
        }, { signal });
        track.addEventListener('scroll', () => {
          hydrateNeighbors(index());
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(sync);
          clearTimeout(settleTimer);
          settleTimer = setTimeout(() => { sync(); target = current; }, 160);
        }, { passive: true, signal });
        track.addEventListener('scrollend', () => { sync(); target = current; }, { signal });
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let value = target + ((event.key === 'ArrowRight') !== rtl ? 1 : -1);
          if (event.key === 'Home') value = 0;
          if (event.key === 'End') value = slides.length - 1;
          const focusImage = slides.includes(document.activeElement);
          go(value, focusImage);
          if (focusImage) slides[target].focus({ preventScroll: true });
        }, { signal });
        track.addEventListener('dragstart', event => event.preventDefault(), { signal });
        track.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          suppressUntil = 0;
          gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, left: track.scrollLeft, mouse: event.pointerType === 'mouse', moved: false };
          target = index();
          hydrateNeighbors(target);
        }, { signal });
        track.addEventListener('pointermove', event => {
          if (!gesture || gesture.id !== event.pointerId) return;
          const dx = event.clientX - gesture.x;
          const dy = event.clientY - gesture.y;
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) gesture.moved = true;
          if (gesture.mouse && gesture.moved) {
            event.preventDefault();
            this.classList.add('is-dragging');
            if (!track.hasPointerCapture(event.pointerId)) track.setPointerCapture(event.pointerId);
            track.scrollLeft = gesture.left - dx;
          }
        }, { signal });
        const finish = event => {
          if (!gesture || gesture.id !== event.pointerId) return;
          if (gesture.moved || Math.abs(track.scrollLeft - gesture.left) > 8) suppressUntil = performance.now() + 600;
          const mouse = gesture.mouse;
          const moved = gesture.moved;
          gesture = null;
          this.classList.remove('is-dragging');
          if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
          if (mouse && moved) go(index());
          else target = index();
        };
        track.addEventListener('pointerup', finish, { signal });
        track.addEventListener('pointercancel', finish, { signal });
        track.addEventListener('pointerleave', event => { if (gesture && !track.hasPointerCapture(event.pointerId)) finish(event); }, { signal });
        track.addEventListener('click', event => {
          if (event.detail !== 0 && performance.now() < suppressUntil) { event.preventDefault(); event.stopPropagation(); }
        }, { capture: true, signal });
        this.resizeObserver = new ResizeObserver(() => go(current, true));
        this.resizeObserver.observe(track);
        this.cleanup = () => { cancelAnimationFrame(frame); clearTimeout(settleTimer); };
        sync();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        this.cleanup?.();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kinsora-stacked-together"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  function mount(root) {
    if (root.dataset.stackMounted) return;
    root.dataset.stackMounted = 'true';
    const host = root.closest('.shopify-section') || root.parentElement;
    const purchase = root.closest('[data-ks-set-purchase]') || host.querySelector('[data-ks-set-purchase]');
    const rows = Array.from(root.querySelectorAll('[data-stack-item]'));
    const button = root.querySelector('[data-stack-add]');
    const error = root.querySelector('[data-stack-error]');
    let busy = false;
    let unsafe = false;
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: root.dataset.currency || 'USD'});
    function value(row) {
      const select = row.querySelector('[data-stack-variant]');
      const option = select.selectedOptions[0];
      return {
        id: Number(select.value),
        quantity: 1,
        price: Number(option && option.dataset.price || 0),
        compare: Number(option && option.dataset.compare || 0),
        image: option && option.dataset.image,
        imageSrcset: option && option.dataset.imageSrcset,
        available: !!option && !option.disabled,
        checked: row.querySelector('[data-stack-check]').checked
      };
    }
    function render() {
      let total = 0;
      let comparison = 0;
      let count = 0;
      rows.forEach(function (row) {
        const item = value(row);
        const checkbox = row.querySelector('[data-stack-check]');
        const select = row.querySelector('[data-stack-variant]');
        checkbox.disabled = busy || unsafe || !item.available;
        select.disabled = busy || unsafe || !Array.from(select.options).some(function (option) { return !option.disabled; });
        if (!item.available) checkbox.checked = false;
        row.classList.toggle('is-unchecked', !checkbox.checked);
        row.querySelector('[data-stack-price]').textContent = money.format(item.price / 100);
        const compare = row.querySelector('[data-stack-compare]');
        compare.textContent = money.format(item.compare / 100);
        compare.hidden = item.compare <= item.price;
        const image = row.querySelector('img');
        const imageLink = row.querySelector('[data-stack-image]');
        if (image && imageLink && item.image && imageLink.dataset.stackImage !== item.image) {
          if (item.imageSrcset) image.srcset = item.imageSrcset;
          image.src = item.image;
          imageLink.dataset.stackImage = item.image;
        }
        if (checkbox.checked && item.available) {
          total += item.price;
          comparison += Math.max(item.price, item.compare);
          count += 1;
        }
      });
      root.querySelector('[data-stack-total]').textContent = money.format(total / 100);
      const compare = root.querySelector('[data-stack-total-compare]');
      compare.textContent = money.format(comparison / 100);
      compare.hidden = comparison <= total;
      button.disabled = busy || unsafe || count === 0;
      button.textContent = busy ? root.dataset.addingLabel : count ? root.dataset.addLabel : root.dataset.emptyLabel;
      button.setAttribute('aria-busy', String(busy));
    }
    function syncPrimary() {
      if (busy) return;
      const primary = root.querySelector('[data-stack-primary]');
      if (!primary) return;
      let id;
      if (purchase && typeof purchase.ksPdpSelection === 'function') id = purchase.ksPdpSelection().variantId;
      else {
        const input = host.querySelector('#variantIdInput');
        if (input) id = input.value;
      }
      const select = primary.querySelector('[data-stack-variant]');
      if (id && Array.from(select.options).some(function (option) { return option.value === String(id); })) select.value = String(id);
      render();
    }
    root.addEventListener('change', function (event) {
      if (busy || unsafe) return;
      const row = event.target.closest('[data-stack-item]');
      if (!row) return;
      error.hidden = true;
      if (row.hasAttribute('data-stack-primary') && event.target.matches('[data-stack-variant]')) {
        if (purchase && typeof purchase.ksSelectVariant === 'function') {
          if (!purchase.ksSelectVariant(event.target.value)) syncPrimary();
        }
        else {
          const input = host.querySelector('#variantIdInput');
          if (input) input.value = event.target.value;
        }
      }
      render();
    });
    host.addEventListener('kinsora:pdp-selection-changed', syncPrimary);
    host.addEventListener('change', function (event) { if (!root.contains(event.target)) window.setTimeout(syncPrimary, 0); });
    host.addEventListener('click', function (event) { if (!root.contains(event.target)) window.setTimeout(syncPrimary, 0); });
    button.addEventListener('click', async function () {
      if (busy || unsafe) return;
      const selected = rows.map(value).filter(function (item) { return item.checked && item.available; });
      if (!selected.length || selected.some(function (item) { return !Number.isSafeInteger(item.id) || item.id <= 0; })) return;
      const runtime = window.Kinsora;
      if (!runtime || typeof runtime.runWhenSynchronizedPaidCartMutationReady !== 'function') {
        error.textContent = root.dataset.runtimeLabel;
        error.hidden = false;
        return;
      }
      busy = true;
      error.hidden = true;
      render();
      let added = false;
      const rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      const serial = Date.now() + '-' + Math.random().toString(36).slice(2, 9);
      const items = selected.map(function (item, index) {
        return {id: item.id, quantity: 1, properties: {_kinsora_cart_unit: serial + '-' + index}};
      });
      const operation = async function () {
        const controller = new AbortController();
        let timer;
        const deadline = new Promise(function (_, reject) {
          timer = window.setTimeout(function () {
            const timeout = new Error(root.dataset.reviewLabel);
            timeout.kinsoraUnsafeCartState = true;
            reject(timeout);
            controller.abort();
          }, 15000);
        });
        try {
          return await Promise.race([deadline, (async function () {
            const response = await fetch(rootPath + 'cart/add.js', {
              method: 'POST', credentials: 'same-origin', signal: controller.signal,
              headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({items: items})
            });
            if (response.ok) added = true;
            const payload = await response.json();
            if (!response.ok) {
              const failure = new Error(payload.description || payload.message || root.dataset.errorLabel);
              failure.status = response.status;
              if (response.status >= 500) failure.kinsoraUnsafeCartState = true;
              throw failure;
            }
            return payload;
          })()]);
        } catch (failure) {
          if (!failure.status || added) failure.kinsoraUnsafeCartState = true;
          throw failure;
        } finally { window.clearTimeout(timer); }
      };
      try {
        await runtime.runWhenSynchronizedPaidCartMutationReady(operation);
        if (typeof runtime.openCart === 'function') runtime.openCart();
        else window.location.assign(rootPath + 'cart');
      } catch (failure) {
        const canonicalItems = failure.kinsoraCanonicalCart && failure.kinsoraCanonicalCart.items || [];
        const partiallyAdded = canonicalItems.some(function (line) {
          return items.some(function (item) {
            return line.properties && line.properties._kinsora_cart_unit === item.properties._kinsora_cart_unit;
          });
        });
        unsafe = added || partiallyAdded || !!failure.kinsoraUnsafeCartState;
        error.textContent = unsafe ? root.dataset.reviewLabel : failure.message || root.dataset.errorLabel;
        error.hidden = false;
      } finally {
        busy = false;
        syncPrimary();
        render();
      }
    });
    syncPrimary();
    render();
  }
  function init(scope) {
    if (scope.matches && scope.matches('[data-stack-together]')) mount(scope);
    scope.querySelectorAll('[data-stack-together]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, {once: true});
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-bogo-offer"] && !Shopify.designMode) return;
  try {
    (function () {
  function syncGiftPouchColor() {
    var drawer = document.getElementById('cartDrawer');
    if (!drawer || !drawer.hasAttribute('data-pouch-present')) return;
    var variantId = drawer.dataset.pouchPresent === 'true'
      ? String(drawer.dataset.pouchVariantId || drawer.dataset.currentPouchVariantId || '') : 'default';
    document.querySelectorAll('[data-gift-offer]').forEach(function (panel) {
      var pouch = panel.querySelector('[data-gift-pouch]');
      var templates = Array.from(panel.querySelectorAll('[data-pouch-template]'));
      var template = templates.find(function (item) { return item.dataset.pouchTemplate === variantId; });
      if (!pouch || !template || pouch.dataset.shownVariant === variantId) return;
      var image = pouch.querySelector('.ks-gift-offer__image');
      if (image) image.replaceChildren(template.content.cloneNode(true));
      var label = pouch.querySelector('[data-pouch-color]');
      if (label) label.textContent = template.dataset.color;
      var price = pouch.querySelector('[data-gift-regular-price]');
      if (price) price.textContent = template.dataset.price;
      pouch.dataset.shownVariant = variantId;
    });
  }
  syncGiftPouchColor();
  document.addEventListener('DOMContentLoaded', syncGiftPouchColor);
  document.addEventListener('kinsora:cart-drawer-updated', syncGiftPouchColor);
  document.addEventListener('kinsora:reward-state', syncGiftPouchColor);
  document.addEventListener('shopify:section:load', syncGiftPouchColor);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-cart-rewards-progress"] && !Shopify.designMode) return;
  try {
    function kinsoraRewardState(subtotal, threshold, gift) {
    if (!(subtotal > 0)) return 'empty';
    if (!gift.present && !gift.available) return 'unavailable';
    if (!Number.isFinite(threshold) || threshold <= 0) return 'unknown';
    if (subtotal < threshold) return 'remaining';
    if (gift.present) return gift.free ? 'added' : 'pending_discount';
    return 'eligible';
  }
  function refreshKinsoraRewards() {
    document.querySelectorAll('[data-ks-rewards]').forEach(function (node) {
      var model;
      try { model = JSON.parse(node.dataset.rewardsState); } catch (error) { return; }
      var rate = node.dataset.currency === node.dataset.baseCurrency ? 1 : Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
      var track = node.querySelector('[data-reward-track]');
      var target = Number.isFinite(rate) && rate > 0 ? Math.round(7500 * rate) : null;
      var subtotal = Number(node.dataset.subtotal);
      var state = kinsoraRewardState(subtotal, target, model.bracelet);
      var pouchState = kinsoraRewardState(subtotal, 1, model.pouch);
      if (window.Kinsora && window.Kinsora.rewardSyncFailed) {
        if (state === 'eligible') state = 'failed';
        if (pouchState === 'eligible') pouchState = 'failed';
      }
      var formatter;
      try { formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:node.dataset.currency, currencyDisplay:'code'}); } catch (error) { return; }
      var thresholdMoney = target ? formatter.format(target / 100) : '$75 USD';
      var label = model.copy.label.replace('[amount]', thresholdMoney);
      track.setAttribute('aria-label', label);
      track.hidden = !target || state === 'unavailable';
      var remaining = target ? Math.max(0, target - subtotal) : 0;
      var fill = target ? Math.min(100, Math.max(0, subtotal / target * 100)) : 0;
      track.setAttribute('aria-valuenow', String(Math.round(fill)));
      node.querySelector('[data-reward-fill]').style.width = fill + '%';
      var end = node.querySelector('[data-reward-end]');
      end.classList.toggle('is-unlocked', state === 'added');
      end.querySelector('[data-reward-gift-icon]').style.display = state === 'added' ? 'none' : 'block';
      end.querySelector('[data-reward-check]').hidden = state !== 'added';
      node.querySelector('[data-reward-message]').textContent = model.copy['bracelet_' + state] || (!target ? node.dataset.goalTemplate.replace('[amount]', '$75 USD') : node.dataset.remainingTemplate.replace('[amount]', formatter.format(remaining / 100)));
    });
  }
  refreshKinsoraRewards();
  document.addEventListener('kinsora:cart-drawer-updated', refreshKinsoraRewards);
  document.addEventListener('kinsora:reward-state', refreshKinsoraRewards);
  document.addEventListener('shopify:section:load', refreshKinsoraRewards);
  new MutationObserver(function (records) {
    if (records.some(function (record) { return Array.from(record.addedNodes).some(function (node) { return node.nodeType === 1 && (node.matches('[data-ks-rewards]') || node.querySelector('[data-ks-rewards]')); }); })) refreshKinsoraRewards();
  }).observe(document.body, {childList:true, subtree:true});
  } catch(e) { console.error(e); }
})();

})();
